import React, { useMemo } from 'react';
import { Box } from '@withjoy/joykit';
import { PhotoCarousel } from '@shared/components/PhotoCarousel';
import { AccommodationListingDTO } from '@apps/accommodations/AccommodationsConsole.types';
import { Skeleton } from '@shared/components/Skeleton';

interface PhotoContainerProps {
  children: React.ReactNode;
  isMobile?: boolean;
}

const Container = ({ children }: PhotoContainerProps) => {
  return (
    <Box aspectRatio={{ _: '16/9', md: '.96/1.25' }} maxWidth={{ _: '100%', md: 220 }} minWidth={{ _: '100%', md: 220 }}>
      {children}
    </Box>
  );
};

interface ListingPhotosProps {
  listing: AccommodationListingDTO;
  isMobile?: boolean;
}

const ListingPhotos = ({ listing, isMobile }: ListingPhotosProps) => {
  const images = useMemo(() => {
    return (
      listing.mediaAssets?.photos.map(x => ({
        src: x.url,
        alt: listing.name
      })) || []
    );
  }, [listing]);

  return (
    <Container>
      <PhotoCarousel
        imgProps={{
          borderRadius: '10px'
        }}
        aspectRatio={isMobile ? '16/9' : '.96/1.25'}
        navigation={{
          variant: 'minimal',
          visible: 'default'
        }}
        images={images}
      />
    </Container>
  );
};

ListingPhotos.Skeleton = () => {
  return (
    <Container>
      <Skeleton borderRadius={'10px'} width="100%" height="100%" />
    </Container>
  );
};

export { ListingPhotos };
